import { render, staticRenderFns } from "./BannerUpdate.vue?vue&type=template&id=0f105e42&"
import script from "./BannerUpdate.vue?vue&type=script&lang=js&"
export * from "./BannerUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports